import React from 'react'
import TopBar from '../components/TopBar'
import SignupForm from '../components/SignupForm'

// import scss
import '../assets/scss/pages/signup.scss';

const Signup = () => {
    return (
        <div className="page-signup">
            <TopBar page='signup'/>
            <SignupForm />
        </div>
    )
}

export default Signup